
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopySharp } from '@material-ui/icons';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { useParams } from 'react-router-dom';
import Badge from 'components/Badge/Badge';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Código cobertura', accessor: 'cobertura_code'},
  { Header: 'Nombre cobertura', accessor: 'cobertura'},
  { Header: 'Unidad de medida', accessor: 'unit_measurement'},
  { Header: 'Unidad minima', accessor: 'unit_min'},
  { Header: 'Categoria', accessor: 'categoria'},
  { Header: 'Linea ', accessor: 'linea'},
  { Header: 'Familia', accessor: 'familia'},
  { Header: 'Producto', accessor: 'producto'},
  { Header: 'Tipo', accessor: 'type'},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
const permission = {
  store: 'INCENTIVOS_TIPO_INCENTIVOS_STORE',
  delete: 'INCENTIVOS_TIPO_INCENTIVOS_DELETED',
  update: 'INCENTIVOS_TIPO_INCENTIVOS_UPDATE',
};
export default WithApp(function SaleForceDetail(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);

  const { id, showNotify, rDetails, setRDetails, reload, reglas } = props;
  const [model, setOpen] = useModal();

  const handleChange = (id, field, value) => {
    const index = rDetails.findIndex((item) => item.id == id);
    rDetails[index][field] = value;
    setRDetails([...rDetails]);
  };

  async function updateCuota(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/reglas-cobertura-detalle', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      reload();
      showNotify(response.message, 'error');
    }
  }

  return (
    <>
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={reload}
          reglas={reglas}
          dataRules={id}
        />
      ) : undefined}
      <Card>
        <CardHeader icon>
          <AllowedGuard permission={ConstantPermissions[permission.store]}
            component={
              <CardIcon color="primary">
                <FileCopySharp style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>Listado Detallado de reglas de cobertura
          <span style={{ fontSize: '14px' }}>
            <b>{` (${reglas.cobertura || ''})`}</b>
          </span>
          {dataLoading && <LoadingSpinner />}
          </h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="detalle_reglas"
            defaultWidth={700}
            columns={columns}
            data={
              rDetails?.map((item, i) => {
                const noAssignedBag = (
                  <div className="actions-center">
                    <Badge color="info">No asignado</Badge>
                  </div>
                );
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                        <ButtonDelete
                          entity="sale/grupo-incentivo-detalle"
                          id={item.id}
                          reload={() => {
                            setDataLoading(true);
                            reload();
                            setDataLoading(false);
                          }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  base_rule_id: item.base_rule_id,
                  cobertura_code: item.cobertura_code,
                  cobertura: item.cobertura,
                  unit_measurement: item.unit_measurement === 'UND' ? 'Unidad' : 'Paquete',
                  logi_category_id: item.logi_category_id ?? noAssignedBag,
                  categoria: item.categoria ?? noAssignedBag,
                  logi_line_id: item.logi_line_id ?? noAssignedBag,
                  linea: item.linea ?? noAssignedBag,
                  logi_family_id: item.logi_family_id ?? noAssignedBag,
                  familia: item.familia ?? noAssignedBag,
                  logi_product_id: item.logi_product_id ?? noAssignedBag,
                  producto: item.producto ?? noAssignedBag,
                  type: item.type === 'T' ? 'Todos' : 'N' ? 'Normal' : 'Indefinido',
                  unit_min: (
                    <AllowedGuard
                      permission={ConstantPermissions.INCENTIVOS_TIPO_INCENTIVOS_UPDATE}
                      component={item.unit_min}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="unit_min"
                        margin="normal"
                        value={item.unit_min || ''}
                        onChange={(e) => handleChange(item.id, 'unit_min', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'unit_min', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              }) || []
            }
          />
        </CardBody>
      </Card>
    </>
  );
});
